import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateRequiredFields } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredFields';
import { validateEmail } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';
import { validatePhoneNumber } from '@framework/ui/Organisms/FinalForm/validators/user/validatePhoneNumber';

const firstName = { fieldName: 'firstName', fieldCaption: 'First Name' };
const lastName = { fieldName: 'lastName', fieldCaption: 'Last Name' };
const companyName = { fieldName: 'companyName', fieldCaption: 'Company Name' };
const email = { fieldName: 'email', fieldCaption: 'Email' };
const phone = { fieldName: 'phone', fieldCaption: 'Phone' };

export default (values) => groupValidators(
  validateEmail({ ...email, value: values.email }),
  validatePhoneNumber({ ...phone, value: values.phone, isRequired: true }),
  validateRequiredFields([
    firstName,
    lastName,
    companyName,
    email,
    phone,
  ], values),
);
